import React, { useContext } from "react";
import { Box, Button, Dialog, Container, Paper, Stack } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Slide from "@mui/material/Slide";

import { DataContext } from "../context/DataContext";
import Lottie from "lottie-react";
import off from "./media/serverOff.json";

import { ThemeProvider } from "@mui/material/styles";
import { crearTema } from "../theme/theme";
import { EstadoError, PageHeader } from "./base";
import { useNavigate } from "react-router-dom";
import { apiLogOut } from "../api/Account";
import { getRuta } from "../helpers/Helpers";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ServerOff = () => {
  const { title, icon, isDarkMode, setIsDarkMode, setIsLogged } = useContext(DataContext);
  const navigate = useNavigate();

  // Sin salida, quien quedaba aquí no podía entrar con otro usuario: igual que "Cerrar sesión" del
  // menú de la cuenta.
  const cerrarSesion = () => {
    apiLogOut();
    setIsDarkMode(false);
    setIsLogged(false);
    navigate(getRuta());
  };

  const tema = crearTema(isDarkMode ? "dark" : "light");

  return (
    <div>
      <ThemeProvider theme={tema}>
        <Dialog
          fullScreen
          open={true}
          TransitionComponent={Transition}
          PaperProps={{
            "aria-label": "Servidor fuera de acceso",
            sx: { bgcolor: "background.default" },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <img
                loading="lazy"
                src={icon}
                alt="Logo"
                style={{ height: 40 }}
              />
              <Typography
                sx={{
                  ml: 2,
                  flex: 1,
                  textAlign: "center",
                  fontWeight: 700,
                  color: "primary.main",
                }}
                variant="h5"
                component="div"
              >
                {`${title}`}
              </Typography>
            </Toolbar>
          </AppBar>

          <Container maxWidth={false} sx={{ py: 3 }}>
            <Paper sx={{ p: { xs: 2, md: 3 } }}>
              <PageHeader titulo="Servidor fuera de acceso" />

              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                alignItems={"center"}
                spacing={2}
              >
                {/* Ilustración decorativa */}
                <Box
                  aria-hidden="true"
                  sx={{ width: { xs: "100%", md: 800 }, maxWidth: "100%" }}
                >
                  <Lottie
                    animationData={off}
                    loop={true}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  />
                </Box>
                <Stack sx={{ flex: 1 }}>
                  <EstadoError
                    titulo="¡No tienes acceso al servidor!"
                    mensaje="Comunícate con Sistemas."
                  />
                  <Box sx={{ textAlign: "center", mt: 2 }}>
                    <Button variant="outlined" startIcon={<LogoutIcon />} onClick={cerrarSesion}>
                      Cerrar sesión
                    </Button>
                  </Box>
                </Stack>
              </Stack>
            </Paper>
          </Container>
        </Dialog>
      </ThemeProvider>
    </div>
  );
};

export default ServerOff;
